import { NgModule } from '@angular/core';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { TextMaskModule } from 'angular2-text-mask';
import { AddCharterComponent } from './add.component';
import { AddCharterResolve } from './add.resolve';
import { SharedModule } from '../../../shared/shared.module';
import { AppCalendarModule } from '../../../shared/calendar/app-calendar.module';
import { UserSearchDialogModule } from '../../../shared/dialogs/user-search-dialog/user-search-dialog.module';
import { EditCharterCustomerInfoHeadingModule } from '../edit-charter-customer-info-heading/edit-charter-customer-info-heading.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AdminWarningDialogModule } from './admin-warning/admin-warning-dialog.module';
import { HelpDialogModule } from '../../../public/help-dialog/help-dialog.module';

@NgModule({
  imports: [
    CommonModule,
    MatCardModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    FlexLayoutModule,
    TextMaskModule,
    MatDialogModule,
    MatListModule,
    MatDatepickerModule,
    MatRadioModule,
    SharedModule,
    MatIconModule,
    AppCalendarModule,
    MatExpansionModule,
    UserSearchDialogModule,
    EditCharterCustomerInfoHeadingModule,
    MatTooltipModule,
    HelpDialogModule,
    AdminWarningDialogModule,
  ],
  declarations: [AddCharterComponent],
  entryComponents: [],
  exports: [AddCharterComponent],
  providers: [AddCharterResolve, CurrencyPipe],
})
export class AddCharterModule {}
